/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { AlarmCodeService } from './AlarmCodeService';

class AlarmCodeServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new AlarmCodeService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { AlarmCodeServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/service/AlarmCodeServiceProvider.js